import { startbeitragRegistrieren, type Kernaktion, type Startlage } from "../plattform/startansicht";

/**
 * Hauptaktion des Kontexts Strecke auf der Startansicht (oberflaeche.md §4.3; design/README §10.2, Referenz
 * `#s-wildversorgung`): Wildversorgung „Strecke“ in jeder Phase. Für Jagdherr und Jagdleiter ist „Strecke“ ein weiteres
 * Ziel der Rolle (drueckjagd/ziele.ts).
 */
const RANG_WILDVERSORGUNG = 9;

function useStreckenbeitrag({ drueckjagdId: id, rollen }: Startlage) {
  const kernaktionen: Kernaktion[] = rollen.includes("Wildversorgung")
    ? [{ begriff: "Strecke", symbol: "strecke", pfad: `/drueckjagd/${id}/strecke`, rang: RANG_WILDVERSORGUNG, haupt: true, nurAlsHaupt: true }]
    : [];
  return { kernaktionen };
}

startbeitragRegistrieren(useStreckenbeitrag);
